import { ReactNode, memo } from "react";
import styled from "styled-components";

const StyledH1 = styled.h1<{ $align: string }>`
  margin-bottom: 10px;
  text-align: ${(props) => props.$align};
  font-size: 1.6rem;

  @media only screen and (min-width: 993px) {
    font-size: 2rem;
    margin-bottom: 30px;
  }
`;

interface PageTitleProps {
  children: ReactNode;
  className?: string | undefined;
  align?: "left" | "center" | "right";
}

const PageTitle = (props: PageTitleProps) => {
  const { children, align = "center", className } = props;

  return (
    <StyledH1 className={className} $align={align}>
      {children}
    </StyledH1>
  );
};

export default memo(PageTitle);
